import { useTheme } from '@emotion/react';
import { TableCell, TableHead, TableRow, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

const FailedPostNestedGridHead = () => {
  const { t: translate } = useTranslation();
  const getTableDesk = [
    { id: 'updated_at', label: translate('approval.tab.updated_at'), alignRight: false },
    { id: 'description', label: translate('approval.tab.post_content'), alignRight: false },
    { id: 'media', label: translate('approval.tab.media'), alignRight: false },
    { id: 'failure-reason', label: translate('failed_post.failure_reason'), alignRight: false },
    { id: 'post_id', label: translate('failed_post.post_id'), alignRight: false },
    { id: 'scheduled-for', label: translate('approval.tab.scheduled_for'), alignRight: false },
    { id: 'action', label: translate('common.action'), alignRight: true },
  ];
  const getTableMobile = [
    { id: 'description', label: translate('approval.tab.post_content'), alignRight: false },
    { id: 'failure-reason', label: translate('failed_post.failure_reason'), alignRight: false },
    { id: 'updated_at', label: translate('approval.tab.updated_at'), alignRight: false },
    { id: 'action', label: translate('common.action'), alignRight: true },
  ];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const TABLE_HEAD = isMobile ? getTableMobile : getTableDesk;

  return (
    <TableHead>
      <TableRow>
        {TABLE_HEAD.map((row, i) => {
          return (
            <>
              <TableCell align={row.alignRight ? 'right' : 'left'}>{row.label}</TableCell>
            </>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default FailedPostNestedGridHead;
